import React, { type ChangeEvent, useCallback } from "react";
import { FileModel } from "@admin/domain/files/model/FileModel";
import FileInput from "@admin/components/FileInput";

type Props = {
    name: string;
    url: string | null;
    urlPreview: FileModel | null;
    onChange: (value: string | null) => void;
    disabled: boolean;
};

export default function Link({ name, url, urlPreview, onChange, disabled }: Props) {
    const onUrlChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        onChange(`${event.target.value}`.trim() || null);
    }, []);

    const remove = useCallback((): void => {
        if (confirm(`Вы действительно хотите удалить ссылку?`)) {
            onChange(null);
        }
    }, []);

    if (disabled) {
        return null;
    }

    return (
        <>
            <div className="mb-5">
                <label className="form-label">Ссылка на YouTube или VK Видео</label>

                <div className="input-group">
                    <input className="form-control" name={`${name}[url]`} value={url || ``} onChange={onUrlChange} />

                    {url && (
                        <button type="button" className="btn btn-outline btn-outline-secondary" onClick={remove}>
                            <i title="Удалить" className="fa fa-trash text-danger" />
                        </button>
                    )}
                </div>
            </div>

            <div className="mb-5">
                <FileInput
                    name={`${name}[url_preview]`}
                    label="Изображение-превью"
                    accept="image/*"
                    defaultValue={urlPreview}
                />
            </div>
        </>
    );
}
